/** Shortest screen side at or above this is a tablet or larger. Same cutoff as Android sw600dp. */
export const BIG_DISPLAY_SHORT_SIDE_PX = 600;

export function isIphoneUserAgent(userAgent) {
  return /iPhone|iPod/i.test(userAgent || '');
}

export function isIpadUserAgent(userAgent, maxTouchPoints) {
  const ua = userAgent || '';
  if (/iPad/i.test(ua)) return true;
  // iPadOS Safari sends a desktop Macintosh UA and reports touch points.
  return /Macintosh/i.test(ua) && Number(maxTouchPoints) > 1;
}

export function isAndroidPhoneUserAgent(userAgent) {
  const ua = userAgent || '';
  return /Android/i.test(ua) && /Mobile/i.test(ua);
}

export function readScreenShortSide(screenObj) {
  if (!screenObj) return undefined;
  const width = Number(screenObj.width);
  const height = Number(screenObj.height);
  if (!Number.isFinite(width) || !Number.isFinite(height)) return undefined;
  return Math.min(width, height);
}

/**
 * Portrait is required on iPhone and Android phones.
 * iPad, Android tablets, and other big displays may rotate.
 */
export function shouldLockPortrait({ userAgent, maxTouchPoints, screenShortSide } = {}) {
  if (isIpadUserAgent(userAgent, maxTouchPoints)) return false;
  if (isIphoneUserAgent(userAgent)) return true;
  if (typeof screenShortSide === 'number' && screenShortSide >= BIG_DISPLAY_SHORT_SIDE_PX) return false;
  return isAndroidPhoneUserAgent(userAgent);
}
